import styled from 'styled-components';

export const Container = styled.div`
  left: 64px;
  top: 64.56px;
  display: flex;
  width: calc(100vw - 44px);
  min-height: calc(100vh - 64.56px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  margin-left: -20px !important;
  background-image: url(/images/background-home.jpg);
  background-size: cover;
  background-position: center;
  position: absolute;
`;

export const Box = styled.div`
  /* margin: 0 auto;
    width: 70%;
    max-width: 700px;
    height: 400px;
    border-radius: 10px; */
`;

export const Image = styled.img`
  opacity: 0.1;
  width: 500px;
  margin-top: -100px;
`;
